export default __webpack_public_path__ + "static/media/camera.6a5ae2c5.svg";